/**
 * 未开通章节/课时点击提示。purchaseSwitch 关联系学管，开则提示购买。
 */
// 功能：未开通章/课提示文案；类型：新增；时间：2026-08-19 10:36:00
// 范围：getLockedNeedBuyTip
// 思路：按店铺购买开关返回对应文案
export const getLockedNeedBuyTip = (purchaseSwitch) => {
  // 1. 开启购买走购课提示，关闭走学管提示
  return purchaseSwitch
    ? '该视频非试看课程，请先购买课程'
    : '该视频非试看课程，请先联系学管老师了解更多课程详情'
}
